<template>
  <div class="ibox">
    <div class="ibox-title">
      <h2>
        Load Overview

        <a v-if="canEditLoadDetails" @click="handleEditingOverview" class="btn btn-info btn-circle pull-right"><i class="fa fa-pencil"></i></a>
      </h2>
    </div>
    <div class="ibox-content ibox-content-padding-xs">

      <div class="row">
        <div class="col-lg-6">
          <!-- Show overview if not editing -->
          <div class="job-overview-details job-overview-details-load" v-show="!editingOverview">
            <div class="row row-clear-sm-6">
              <div class="col-xs-6">
                <p>
                  <strong>Load Reference</strong><br />
                  {{ loadDecorated.reference_number }}
                </p>
              </div>
              <div class="col-xs-6">
                <p>
                  <strong>Commodity</strong><br />
                  {{ loadDecorated.commodity_name}}
                </p>
              </div>
              <div class="col-xs-6">
                <p>
                  <strong>Load Size</strong><br />
                  {{ loadDecorated.size }}
                </p>
              </div>
              <div class="col-xs-6">
                <p>
                  <strong>Rate</strong><br />
                  {{ loadDecorated.rate }}
                </p>
              </div>
              <div class="col-xs-6">
                <p>
                  <strong>Loading Date</strong><br />
                  {{ loadDecorated.loading_date }}
                </p>
              </div>
              <div class="col-xs-6">
                <p>
                  <strong>Loading Time</strong><br />
                  {{ loadDecorated.loading_time }}
                </p>
              </div>
              <div class="col-xs-6">
                <p>
                  <strong>Delivery Date</strong><br />
                  {{ loadDecorated.delivery_date }}
                </p>
              </div>
              <div class="col-xs-6">
                <p>
                  <strong>Delivery Time</strong><br />
                  {{ loadDecorated.delivery_time }}
                </p>
              </div>
              <div v-if="loadDecorated.job" class="col-xs-6">
                <p>
                  <strong>Pickup Reference</strong><br />
                  {{ loadDecorated.job.pickup_reference }}
                </p>
              </div>
              <div v-if="loadDecorated.job" class="col-xs-6">
                <p>
                  <strong>Delivery Reference</strong><br />
                  {{ loadDecorated.job.delivery_reference }}
                </p>
              </div>
              <div v-if="loadDecorated.job" class="col-xs-6">
                <p>
                  <strong>Order</strong><br />
                  {{ loadDecorated.job.order_reference }}
                </p>
              </div>
              <div v-if="loadDecorated.notes" class="col-xs-12">
                <p>
                  <strong>Driver Notes</strong><br />
                  {{ loadDecorated.notes }}
                </p>
              </div>
            </div>
          </div>

          <!-- Otherwise show fields to edit -->
          <div class="job-overview-details job-overview-details-load" v-show="editingOverview">
            <div class="row row-clear-sm-6">
              <div class="col-sm-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control">
                    <label for="">Load Size</label>
                    <input type="number" v-model="loadSize" min="0" class="form-control" placeholder="Load Size" v-float-label/>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control">
                    <label for="" class="select-label">Loading Time</label>
                    <flat-pickr class="form-control" name="loading_time" v-model="loadingTime" :config="flatPickerConfig"  placeholder="Loading Time" v-float-label></flat-pickr>
                    <!--<input type="text" v-model="loadingTime" class="form-control" placeholder="Loading Time" v-float-label/>-->
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control">
                    <label for="">Loading Date</label>
                    <date-range v-model="loadingDate" name="loading_date" :single-date-picker="true" opens="right" v-float-label></date-range>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control">
                    <label for="" class="select-label">Delivery Time</label>
                    <flat-pickr class="form-control" v-model="deliveryTime" name="delivery_time" :config="flatPickerConfig"  placeholder="Delivery Time" v-float-label></flat-pickr>
                    <!--<input type="text" v-model="deliveryTime" class="form-control" placeholder="Delivery Time" v-float-label/>-->
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control">
                    <label for="">Delivery Date</label>
                    <date-range v-model="deliveryDate" name="delivery_date" :single-date-picker="true" opens="right" v-float-label></date-range>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group-outer">
                  <div class="form-group float-label-control">
                    <label for="">Driver Notes</label>
                    <textarea type="text" v-model="notes" rows="2" class="form-control" placeholder="Driver Notes" v-float-label/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">

          <div class="truck-selection">
            <div class="row">
              <div v-if="$user.isAdminOrCoordinator" class="col-lg-6 col-md-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control">
                    <label for="" class="select-label">Carrier</label>
                    <selectize
                      v-model="carrier"
                      name="carrier_id"
                      :options="carrierOptions"
                      :disabled="jobIsNotEditable"
                      :fetch-results="fetchCarrierResults">
                    </selectize>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control">
                    <label for="" class="select-label">Truck</label>
                    <selectize
                      v-model="truck"
                      name="truck_id"
                      :options="truckOptions"
                      :disabled="jobIsNotEditable"
                      :fetch-results="fetchTruckResults">
                    </selectize>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control">
                    <label for="" class="select-label">Configuration</label>
                    <selectize
                      v-model="truckConfiguration"
                      name="truck_configuration_id"
                      :disabled="jobIsNotEditable"
                      :options="configurationOptions">
                    </selectize>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group-outer last-input">
                  <div class="form-group float-label-control">
                    <label for="" class="select-label">Driver</label>
                    <selectize
                      v-model="driver"
                      name="driver_id"
                      :options="driverOptions"
                      :disabled="jobIsNotEditable"
                      :fetch-results="fetchDriverResults">
                    </selectize>
                  </div>
                </div>
              <p v-if="hasDevice" class="help-block device-help-block">Driver will be notified</p>
              </div>
              <div class="col-md-12 text-right">
                <!-- TODO: Only show if changes made -->
                <ladda-button
                  v-if="showOverviewSaveButton"
                  type="success"
                  size="small"
                  :on-click="handleSaveOverview">
                  Save
                </ladda-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
  import { LaddaButton, Selectize, DateRange } from 'components/forms'
  import { map, clone, concat, find, get } from 'lodash'
  import { stateMapper } from 'mixins/loads'
  import { jobHelpers } from 'mixins/jobs'
  import { SET_LOAD_ATTRIBUTE } from 'vx/mutations'
  import flatPickr from 'vue-flatpickr-component'
  import { notify } from 'utils'

  export default {
    mixins: [stateMapper, jobHelpers],

    components: {
      LaddaButton,
      Selectize,
      DateRange,
      flatPickr
    },

    data () {
      return {
        trucks: [],
        drivers: [],
        carriers: [],
        configurationOptions: [],
        editingOverview: false,
        flatPickerConfig: {
          altFormat: 'h:i K',
          altInput: true,
          enableTime: true,
          noCalendar: true,
          dateFormat: 'h:i K'
        }
      }
    },

    created () {
      if (this.$user.isAdminOrCoordinator) {
        this.getCarriers().then(carriers => {
          this.carriers = concat(this.carriers, clone(carriers))
        })
      }

      if (this.load.carrier) {
        this.carriers.push(this.load.carrier)
        this.trucks = clone(this.load.carrier.trucks)
        this.drivers = clone(this.load.carrier.drivers)
      }

      if (this.load.truck) {
        this.trucks.push(this.load.truck)

        // With the loads truck we need to set the configuration options that will
        // be available for this specific truck.
        this.setTruckConfigurationOptions(this.load.truck)
      }

      if (this.load.driver) {
        this.drivers.push(this.load.driver)
      }

      this.$watch('carrier', this.setTrucksAndDrivers)
      this.$watch('truck', this.setDriverAndConfigurationOptions)
    },

    computed: {
      ...mapGetters('load', ['loadDecorated']),
      ...mapState('load', ['load']),

      canEditLoadDetails () {
        return this.jobIsEditable && this.$user.isAdminOrCoordinator
      },

      showOverviewSaveButton () {
        return this.jobIsEditable
      },

      /**
       * Carrier options.
       *
       * @return array
       */
      carrierOptions () {
        return map(this.carriers, carrier => ({ id: carrier.id, text: carrier.profile.company_name }))
      },

      /**
       * Truck options.
       *
       * @return array
       */
      truckOptions () {
        return map(this.trucks, truck => ({ id: truck.id, text: truck.registration }))
      },

      /**
       * Driver options.
       *
       * @return array
       */
      driverOptions () {
        return map(this.drivers, driver => ({ id: driver.id, text: `${driver.profile.full_name}` }))
      },

      /**
       * Determine if  if the selected driver has a device
       */
      hasDevice () {
        if (this.driver) {
          let loadDriver = find(this.drivers, driver => {
            return driver.id === this.driver
          })

          if (loadDriver && loadDriver.devices && loadDriver.devices.length > 0) {
            return true
          }
        }
        return false
      }
    },

    methods: {
      ...mapActions('carrier', ['getCarriers']),
      ...mapActions('truck', ['getTrucks', 'getTruck']),
      ...mapActions('driver', ['getDrivers']),
      ...mapActions('load', ['updateLoad']),
      ...mapMutations('load', [SET_LOAD_ATTRIBUTE]),

      /**
       * Set the trucks and drivers.
       *
       * @return void
       */
      setTrucksAndDrivers () {
        this.truck = null

        this.getTrucks({ user_id: this.load.carrier_id }).then(this.setTrucks)
        this.getDrivers({ user_id: this.load.carrier_id }).then(this.setDrivers)
      },

      /**
       * Set the driver and configuration options.
       *
       * @return void
       */
      setDriverAndConfigurationOptions () {
        this.driver = null
        this.truckConfiguration = null
        this.configurationOptions = []

        if (!this.truck) {
          return
        }

        this.getTruck(this.truck).then(truck => {
          this.setTruckConfigurationOptions(truck)

          if (truck.driver_id) {
            this.driver = truck.driver_id
          }
        })
      },

      /**
       * Toggle whether or not we are editing the overview details
       *
       * @return void
       */
      handleEditingOverview () {
        this.editingOverview = !this.editingOverview
      },

      /**
       * Save overview details of load
       *
       * @return Promise
       */
      handleSaveOverview () {
        const notifyUpdated = () => (notify.success('Load details have been saved.'))

        let payload = {
          id: this.load.id,
          payload: this.load
        }

        return this.updateLoad(payload)
          .then(notifyUpdated)
          .catch(({ response = {} }) => {
            if (response.status === 422) {
              const errors = get(response, 'data.errors')
              notify.error(get(errors, Object.keys(errors)[0]))
            } else {
              notify.error('Failed to update load details, please contact your support team for more information.')
            }
          })
      },

      /**
       * Set the configuration options for the given truck.
       *
       * @return void
       * @param truck
       */
      setTruckConfigurationOptions (truck) {
        this.configurationOptions = map(truck.configurations, configuration => {
          return { id: configuration.pivot_id, text: `${configuration.net_weight}t ${configuration.description}` }
        })
      },

      /**
       * When admin types in the user select box we need to fetch more users
       * from the api since the users are paginated.
       */
      fetchCarrierResults (name, callback) {
        return this.getCarriers({ name })
          .then(this.setCarriers)
          .then(callback.apply(this.carrierOptions))
      },

      /**
       * When user types in the truck select box we need to fetch more trucks
       * from the api since the trucks are paginated
       */
      fetchTruckResults (search, callback) {
        return this.getTrucks({ user_id: this.carrier, search })
          .then(this.setTrucks)
          .then(callback.apply(this.truckOptions))
      },

      /**
       * When user types in the driver select box we need to fetch more drivers
       * from the api since the drivers are paginated
       */
      fetchDriverResults (name, callback) {
        return this.getDrivers({ user_id: this.carrier, name })
          .then(this.setDrivers)
          .then(callback.apply(this.driverOptions))
      },

      /**
       * Set the local trucks.
       *
       * @param array trucks
       *
       * @return void
       */
      setTrucks ({ data: { data: trucks } }) {
        this.trucks = clone(trucks)
      },

      /**
       * Set the local drivers.
       *
       * @param array drivers
       *
       * @return void
       */
      setDrivers ({ data: { data: drivers } }) {
        this.drivers = clone(drivers)
      },

      /**
       * Set the local carriers.
       *
       *
       * @return void
       * @param data
       */
      setCarriers (data) {
        const carriers = data.data || data
        this.carriers = clone(carriers)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoadOverview.vue?00664804